define('constants/liveReceptionistScriptFollowUpConstants',[], function() {
    return {
        Unknown: "0",
        SameDay: "1",
        WithinTwoDays: "2",
        Other: "3"
    };
});
